import React from "react"
import { connect } from "react-redux"
import withStyles from '@mui/styles/withStyles';
import TextField from "@mui/material/TextField"
import colors from "../../Constants/colors"
import ButtonSelection from "../ButtonSelection/ButtonSelection"
import "./NonDodIcCareerOne.css"
import { industriesList, industriesRemoved } from "../../Utils/industriesList"
import { toggleModal } from "../../Redux/Actions/User/functions"
import { modalUsi } from "../SimpleModal/SimpleModal"

Object.byString = function (o, s) {
  s = s.replace(/\[(\w+)\]/g, ".$1") // convert indexes to properties
  s = s.replace(/^\./, "") // strip a leading dot
  const a = s.split(".")
  for (let i = 0, n = a.length; i < n; ++i) {
    const k = a[i]
    if (o && k in o) {
      o = o[k]
    } else {
      return
    }
  }
  return o
}

const styleSheet = {
  inputText: {
    color: colors.midnight
  },
  label: {
    fontFamily: "Lato-Regular",
    marginTop: "0px",
    color: colors.midnight
  },
  root: {
    fontFamily: "Lato-Semibold",
    marginTop: "0px"
  }
}

class NonDodIcCareerOne extends React.Component {
  constructor(props) {
    super(props)
    this.data = [
      {
        id: 0,
        userField: "interests",
        inputType: "buttonSelection",
        options: industriesList,
        title: `What industries are you interested in?`,
        required: true,
      },
      {
        id: 1,
        userField: "career.otherInterest",
        className: "career.otherInterest",
        inputType: "buttonSelection",
        title: `Other industries of interest`,
        required: false,
      }
    ]

    this.handleChange = this.handleChange.bind(this)

    this.state = {
      inputData: [],
      otherValue:
        Object.byString(
          props.nonDodIcApplication.application,
          "career.otherInterest"
        ) || ""
    }
  }

  handleChange(e) {
    this.setState(
      {
        otherValue: e.target.value
      },
      this.props.changeHandler(
        this.state.inputData.concat([
          {
            userField: "career.otherInterest",
            value: e.target.value
          }
        ])
      )
    )
  }

  render() {
    return (
      <ButtonSelection
        userField={this.data[0].userField}
        limit={5}
        style={{ marginTop: "20px" }}
        {...this.props}
        onLimitExceeded={(limit) => {
          this.props.toggleModal({
            modal_mode: true,
            modal_usi: modalUsi,
            title: "ERROR",
            text: `You can only choose up to ${limit} industries.`
          })
        }}
        inputData={this.data[0].options
          .map((option, index) => {
            const selectedInterests = (this.props.nonDodIcApplication.application && this.props.nonDodIcApplication.application.interests) ? this.props.nonDodIcApplication.application.interests : []
            const isSelected = selectedInterests.some(
              (interest) => interest.name === option
            )
            const isRemoved = industriesRemoved.some(
              (industryRemoved) => industryRemoved === option
            )

            if ((isRemoved && isSelected) || !isRemoved) {
              return {
                id: index,
                value: option,
                isSelected
              }
            }

            return null
          })
          .filter(Boolean)}
        changeHandler={(data) => {
          this.setState(
            {
              inputData: data
            },
            this.props.changeHandler(
              data.concat([
                {
                  userField: "career.otherInterest",
                  value: this.state.otherValue
                }
              ])
            )
          )
        }}
        renderComponent={({ inputComponent, inputData }) => {
          return (
            <>
              {this.props.renderComponent({
                ...this.props,
                inputData: inputData.concat([
                  {
                    userField: "career.otherInterest",
                    value: this.state.otherValue
                  }
                ]),
                inputComponent: (
                  <>
                    {inputComponent}
                    <div
                      className="otherInterestContainer"
                      style={{ marginTop: "50px" }}
                    >
                      <TextField
                        InputLabelProps={{
                          classes: {
                            root: this.props.classes.root
                          }
                        }}
                        classes={{
                          root: this.props.inputText
                        }}
                        value={this.state.otherValue}
                        label="Other"
                        type="text"
                        style={{
                          marginTop: "0px"
                        }}
                        id="standard-dense"
                        margin="dense"
                        onChange={this.handleChange}
                      />
                    </div>
                  </>
                )
              })}{" "}
            </>
          )
        }}
      />
    )
  }
}

const mapStateToProps = (state, props) => {
  return {
    ...props,
    nonDodIcApplication: state.nonDodIcApplication
  }
}

const mapDispatchToProps = { toggleModal }

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styleSheet)(NonDodIcCareerOne))
